/* sgx-landing.js - StoreGrowthX home page interactions.
   Loaded only on templates/index. Self-contained, no globals. */
(function () {
  'use strict';

  // Wait for DOM ready (script is loaded with `defer` so DOM should be parsed).
  function init() {
    if (!document.body.classList.contains('sgx-page')) return;

    var CONFIG = (window.SGX_CONFIG && typeof window.SGX_CONFIG === 'object') ? window.SGX_CONFIG : {};
    if (!CONFIG.email)    CONFIG.email    = 'contact@storegrowthx.com';

    /* 1. Sticky CTA bar visibility - show only when hero is out and final is not in. */
    (function () {
      var sticky = document.querySelector('.sticky-bar');
      var hero = document.querySelector('.sgx-hero');
      var finalSec = document.querySelector('.sgx-final');
      if (!sticky || !hero) return;
      var heroIn = true, finalIn = false;
      var apply = function () {
        var visible = !heroIn && !finalIn;
        sticky.classList.toggle('show', visible);
        document.body.classList.toggle('sgx-cta-shown', visible);
      };
      new IntersectionObserver(function (entries) { heroIn = entries[0].isIntersecting; apply(); }, { threshold: 0.05 }).observe(hero);
      if (finalSec) {
        new IntersectionObserver(function (entries) { finalIn = entries[0].isIntersecting; apply(); }, { threshold: 0.25 }).observe(finalSec);
      }
      apply();
    })();

    /* 2. Mobile nav drawer. */
    (function () {
      var toggle = document.querySelector('[data-open-nav]');
      var drawer = document.getElementById('mobileNav');
      var backdrop = document.querySelector('.mobile-nav-backdrop');
      if (!toggle || !drawer || !backdrop) return;

      var open = function () {
        drawer.classList.add('open');
        backdrop.classList.add('open');
        drawer.setAttribute('aria-hidden', 'false');
        toggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      };
      var close = function () {
        drawer.classList.remove('open');
        backdrop.classList.remove('open');
        drawer.setAttribute('aria-hidden', 'true');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      };

      toggle.addEventListener('click', open);
      document.querySelectorAll('[data-close-nav]').forEach(function (el) {
        el.addEventListener('click', close);
      });
      drawer.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('open')) close();
      });
    })();

    /* 3. Direct-checkout buy buttons. Event-delegated so dynamically inserted
          [data-buy] elements (e.g. the sticky-bar tier-context swap below) also
          fire. Flow: CLEAR cart → POST /cart/add.js → redirect to /checkout. */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-buy]');
      if (!a) return;
      var id = a.getAttribute('data-buy');
      if (!id) return;
      e.preventDefault();
      var label = a.innerHTML;
      a.style.pointerEvents = 'none';
      a.innerHTML = 'Loading…';
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
      }).then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        });
      }).then(function (r) {
        if (!r.ok) throw new Error('cart add failed (' + r.status + ')');
        window.location.href = '/checkout';
      }).catch(function (err) {
        if (window.console && console.error) console.error('[sgx buy]', err);
        a.style.pointerEvents = '';
        a.innerHTML = label;
        // last-ditch fallback: follow the href
        var href = a.getAttribute('href');
        if (href && href !== '#') window.location.href = href;
      });
    });

    /* 4. Stat counters - animate .stat-num from 0 → target when in viewport.
          Parses each cell as "<prefix><number><suffix>" so "$60M+" / "3+ Yrs"
          / "$3M+" / "270+" all work. Honors prefers-reduced-motion. */
    (function () {
      var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var stats = document.querySelectorAll('.stat-num');
      if (!stats.length || !window.IntersectionObserver || prefersReduced) return;

      function parseStat(el) {
        var text = (el.textContent || '').trim();
        var m = text.match(/^([^\d]*)(\d+)(.*)$/);
        if (!m) return null;
        return { prefix: m[1], target: parseInt(m[2], 10), suffix: m[3] };
      }

      function animate(el, info, duration) {
        var start = performance.now();
        (function tick(now) {
          var t = Math.min(1, (now - start) / duration);
          var eased = 1 - Math.pow(1 - t, 3); /* ease-out cubic */
          var current = Math.round(info.target * eased);
          el.textContent = info.prefix + current.toLocaleString() + info.suffix;
          if (t < 1) requestAnimationFrame(tick);
        })(start);
      }

      var seen = new WeakSet();
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting || seen.has(e.target)) return;
          seen.add(e.target);
          var info = parseStat(e.target);
          if (!info) return;
          e.target.textContent = info.prefix + '0' + info.suffix;
          animate(e.target, info, 1500);
          obs.unobserve(e.target);
        });
      }, { threshold: 0.4 });

      stats.forEach(function (el) { obs.observe(el); });
    })();

    /* 5. Contact CTAs - every [data-open="contact"] navigates to /pages/contact.
          The optional `data-tier` attribute is passed as a query param so the contact
          page can pre-select the tier dropdown. Event-delegated so cloned buttons
          (e.g. from the sticky-bar tier swap) fire too. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-open="contact"]');
      if (!btn) return;
      e.preventDefault();
      var tier = btn.dataset.tier || '';
      var url = '/pages/contact' + (tier ? '?tier=' + encodeURIComponent(tier) : '');
      window.location.href = url;
    });

    /* 6. Contact-form helpers (used on the /pages/contact page). Defined at the
          top level so they're available even when no dialog exists. */
    (function () {
      var form = document.getElementById('contactForm');
      if (!form) return;

      function showSuccess(data) {
        var firstName = data.name ? String(data.name).split(' ')[0] : '';
        form.innerHTML =
          '<div class="form-success">' +
            '<div class="success-icn">' +
              '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
            '</div>' +
            '<h3>Thanks' + (firstName ? ', ' + firstName : '') + ' - we got it.</h3>' +
            '<p>We\'ll come back within 24 hours with a kick-off plan and timeline.</p>' +
            '<a href="/" class="btn btn-ghost">Back to home <span class="arr">&rarr;</span></a>' +
          '</div>';
      }

      function showError(submitBtn, originalText) {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalText;
        }
        if (form.querySelector('.form-error-banner')) return;
        var banner = document.createElement('div');
        banner.className = 'form-error-banner';
        banner.innerHTML =
          'Couldn\'t send your request. Please try again' +
          (CONFIG.email ? ' or email <a href="mailto:' + CONFIG.email + '">' + CONFIG.email + '</a> directly' : '') +
          '.';
        var btn = form.querySelector('button[type="submit"]');
        if (btn && btn.parentNode) btn.parentNode.insertBefore(banner, btn);
        else form.appendChild(banner);
      }

      form.addEventListener('submit', function (e) {
        // Honeypot - silently drop bot submissions in both modes.
        if (form.elements.hp && form.elements.hp.value) {
          e.preventDefault();
          return;
        }

        // Save the name to sessionStorage so we can personalize the success greeting
        // after Shopify's post-redirect (Shopify mode) or after AJAX response (external mode).
        var nameField = form.elements['contact[name]'] || form.elements.name;
        if (nameField && nameField.value) {
          try { sessionStorage.setItem('sgx_lead_name', nameField.value); } catch (err) {}
        }

        // ─── External endpoint mode ──────────────────────────────────────────
        // formEndpoint is set in theme settings → JS hijacks submit and POSTs JSON
        // to that endpoint (Formspree, Zapier webhook, custom backend, etc.).
        if (CONFIG.formEndpoint) {
          e.preventDefault();
          if (!form.checkValidity()) { form.reportValidity(); return; }

          var fd = new FormData(form);
          var data = {};
          fd.forEach(function (v, k) {
            if (k === 'hp' || k === 'form_type' || k === 'utf8') return;
            // Strip "contact[" prefix, "]" suffix, and any leading "NN_" ordering prefix.
            var key = k.replace(/^contact\[/, '').replace(/\]$/, '').replace(/^\d+_/, '');
            if (key.slice(-2) === '[]') {
              key = key.slice(0, -2);
              if (!data[key]) data[key] = [];
              data[key].push(v);
            } else {
              data[key] = v;
            }
          });
          data._page = window.location.href;
          data._timestamp = new Date().toISOString();

          var submitBtn = form.querySelector('button[type="submit"]');
          var originalText = submitBtn ? submitBtn.innerHTML : '';
          if (submitBtn) { submitBtn.disabled = true; submitBtn.innerHTML = 'Sending…'; }
          var prevErr = form.querySelector('.form-error-banner');
          if (prevErr) prevErr.parentNode.removeChild(prevErr);

          fetch(CONFIG.formEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(data)
          }).then(function (r) {
            if (!r.ok) throw new Error('submission failed (' + r.status + ')');
            showSuccess(data);
          }).catch(function (err) {
            if (window.console && console.error) console.error('[sgx contact]', err);
            showError(submitBtn, originalText);
          });
          return;
        }

        // ─── Shopify built-in mode (default) ─────────────────────────────────
        // No formEndpoint set → let the form POST natively to /contact. Shopify
        // emails the address in Settings → Notifications → Customer contact and
        // redirects back here with ?form_type=contact&contact[posted_successfully]=true.
        // The post-redirect handler above re-opens the dialog with the success state.
        if (!form.checkValidity()) { e.preventDefault(); form.reportValidity(); return; }
        // Don't preventDefault - let the browser submit the form.
      });
    })();

    /* 7. Mobile horizontal carousels - continuous auto-scroll + manual swipe.
          Mobile-only (≤879px). For each scroller (.problem-grid, .mech-grid,
          .port-grid) - pricing and testimonials intentionally excluded.
          Pricing: users need a stable page to compare tiers. Testimonials:
          only 3 cards, so the seamless-loop clone set was visibly duplicating.
            • Clones each card once (doubles content) for seamless infinite loop.
            • requestAnimationFrame ticker increments scrollLeft ~30 px/sec; when
              it crosses halfWidth, scrollLeft is decremented by halfWidth so the
              user sees the equivalent clone position - no visible jump.
            • scroll-snap is disabled while auto-scrolling and re-enabled when
              the user touches the carousel, so manual swipes still snap nicely.
            • Pauses on touch/mousedown, resumes 2 s after the last interaction.
            • Auto-pauses when the carousel scrolls out of view (perf). */

    /* Pricing carousel: on mobile the .price-grid scroll-snap carousel defaults
       to the first card (Basic). Center the recommended .tier.popular (Standard)
       card instead, so the most popular tier is what visitors land on. Runs on
       home + home2 (both render sgx-pricing). Desktop is a 3-up grid - no-op. */
    (function () {
      if (!window.matchMedia || !window.matchMedia('(max-width: 879px)').matches) return;
      function centerPopular() {
        if (!window.matchMedia('(max-width: 879px)').matches) return;
        document.querySelectorAll('.price-grid').forEach(function (grid) {
          var pop = grid.querySelector('.tier.popular');
          if (!pop) return;
          var gridRect = grid.getBoundingClientRect();
          var popRect = pop.getBoundingClientRect();
          var delta = (popRect.left - gridRect.left) - (grid.clientWidth - pop.clientWidth) / 2;
          grid.scrollLeft += delta; // instant - already centered before the user looks
        });
      }
      centerPopular();
      window.addEventListener('load', centerPopular);
      setTimeout(centerPopular, 300); // after fonts/layout settle
    })();

    /* Pricing peek-hint: each time the centered pricing carousel scrolls into
       view on mobile, nudge it gently right then left so visitors realize the
       Basic and Premium tiers sit just off-screen on either side of the Standard
       card. Replays every time the section re-enters the viewport. Aborts the
       moment the user scrolls/touches it (restoring snap so their swipe feels
       natural) and when the section leaves view. Honors prefers-reduced-motion.
       Applied to every .price-grid so it works the same on home + home2. */
    (function () {
      if (!window.matchMedia || !window.matchMedia('(max-width: 879px)').matches) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;
      var grids = document.querySelectorAll('.price-grid');
      if (!grids.length) return;

      var NUDGE_PX  = 52;   // how far each peek pulls a neighbour into view
      var CYCLES    = 2;    // number of right+left shimmies per visit
      var SHIMMY_MS = 2600; // duration of one continuous out-and-back-both-ways sweep (slow = gentle)
      var GAP_MS    = 1300; // pause between shimmies

      function wireGrid(grid) {
        if (grid.children.length < 2) return;

        // A monotonic run id. Bumping it makes any in-flight frame/timeout see a
        // stale id and bail, so we can cleanly abort and later replay.
        var runId = 0, running = false;

        function abort() { runId++; running = false; }

        function userTookOver() {
          abort();
          grid.style.scrollSnapType = ''; // hand control back: restore CSS mandatory snap
        }
        grid.addEventListener('touchstart',  userTookOver, { passive: true });
        grid.addEventListener('pointerdown', userTookOver);
        grid.addEventListener('wheel',       userTookOver, { passive: true });

        // One shimmy: a single continuous sine sweep relative to the current
        // (centered) home position — 0 → +NUDGE → 0 → -NUDGE → 0. Driven by
        // requestAnimationFrame so it's perfectly smooth and eases at every turn,
        // and lands exactly back on `home` so it can't drift across cycles.
        function shimmy(myId, done) {
          var home = grid.scrollLeft;
          var begin = performance.now();
          (function frame(now) {
            if (myId !== runId) return;
            var t = (now - begin) / SHIMMY_MS;
            if (t >= 1) { grid.scrollLeft = home; done(); return; }
            grid.scrollLeft = home + NUDGE_PX * Math.sin(t * 2 * Math.PI);
            requestAnimationFrame(frame);
          })(begin);
        }

        function run(myId, n) {
          if (myId !== runId) return;
          if (n <= 0) { running = false; return; } // leave snap suspended; stays centered until the user swipes
          shimmy(myId, function () {
            setTimeout(function () { run(myId, n - 1); }, GAP_MS);
          });
        }

        function start() {
          if (running) return;
          running = true;
          var myId = ++runId;
          grid.style.scrollSnapType = 'none'; // suspend snap so the sweep doesn't fight it
          setTimeout(function () {            // let centering settle before moving
            if (myId !== runId) { running = false; return; }
            run(myId, CYCLES);
          }, 500);
        }

        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) start();
            else abort(); // re-entering the viewport later will replay
          });
        }, { threshold: 0.35 }).observe(grid);
      }

      Array.prototype.forEach.call(grids, wireGrid);
    })();

    (function () {
      if (!window.matchMedia || !window.matchMedia('(max-width: 879px)').matches) return;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var scrollers = document.querySelectorAll('.problem-grid, .mech-grid, .port-grid');
      if (!scrollers.length) return;

      scrollers.forEach(function (scroller) {
        if (scroller.dataset.sgxAutoScroll) return; // idempotent - never double-init
        var originals = Array.prototype.slice.call(scroller.children);
        if (originals.length < 2) return;
        scroller.dataset.sgxAutoScroll = '1';

        // Clone for infinite loop. Strip IDs to keep DOM valid.
        originals.forEach(function (card) {
          var clone = card.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('id');
          var ided = clone.querySelectorAll('[id]');
          for (var i = 0; i < ided.length; i++) ided[i].removeAttribute('id');
          scroller.appendChild(clone);
        });

        // Suspend scroll-snap during auto-scroll - mandatory snap fights every
        // sub-pixel scrollLeft change and was the source of the earlier glitch.
        scroller.style.scrollSnapType = 'none';

        var halfWidth = 0;
        function recompute() { halfWidth = scroller.scrollWidth / 2; }
        recompute();
        setTimeout(recompute, 300);
        window.addEventListener('load', recompute);
        var resizeTimer;
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(recompute, 200);
        });

        if (reducedMotion) return; // honor user preference - leave manual scroll alone

        var speedPxPerSec = 60;
        var paused = false;
        var inView = true;
        var resumeTimer = null;
        var lastFrame = performance.now();
        var pendingPx = 0; // fractional accumulator - mobile Safari rounds scrollLeft, so sub-pixel adds can sit on the same integer indefinitely

        function pause(restoreSnap) {
          paused = true;
          pendingPx = 0;
          if (restoreSnap) scroller.style.scrollSnapType = ''; // back to CSS-defined mandatory
          if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; }
        }
        function scheduleResume() {
          if (resumeTimer) clearTimeout(resumeTimer);
          resumeTimer = setTimeout(function () {
            if (!inView) return;
            scroller.style.scrollSnapType = 'none';
            paused = false;
            lastFrame = performance.now();
          }, 2000);
        }

        function tick(now) {
          var dt = now - lastFrame;
          lastFrame = now;
          if (!paused && inView && halfWidth > 0 && dt < 200) { // dt cap avoids huge jumps after tab-switch
            pendingPx += (speedPxPerSec * dt) / 1000;
            if (pendingPx >= 1) {
              var move = Math.floor(pendingPx);
              pendingPx -= move;
              scroller.scrollLeft += move;
              if (scroller.scrollLeft >= halfWidth) {
                scroller.scrollLeft = scroller.scrollLeft - halfWidth;
              }
            }
          }
          requestAnimationFrame(tick);
        }

        scroller.addEventListener('touchstart', function () { pause(true); },  { passive: true });
        scroller.addEventListener('mousedown',  function () { pause(true); });
        scroller.addEventListener('touchend',   scheduleResume, { passive: true });
        scroller.addEventListener('mouseup',    scheduleResume);
        scroller.addEventListener('mouseleave', scheduleResume);

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              inView = e.isIntersecting;
              if (!inView && resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; }
              if (inView && !paused) lastFrame = performance.now();
            });
          }, { threshold: 0.1 }).observe(scroller);
        }

        requestAnimationFrame(tick);
      });
    })();

    /* 8. Sticky-bar contextual CTA - when the pricing section is in view on
          mobile, swap the default "Build my store / Free bundle" pair for the
          currently-visible tier's CTA. Updates live as the user swipes
          horizontally through the tier carousel. */
    (function () {
      if (!window.matchMedia || !window.matchMedia('(max-width: 879px)').matches) return;

      var stickyBar = document.querySelector('.sticky-bar');
      var priceGrid = document.querySelector('.price-grid');
      if (!stickyBar || !priceGrid) return;

      var tiers = Array.prototype.slice.call(priceGrid.querySelectorAll(':scope > .tier'));
      if (!tiers.length) return;

      var defaultHTML = stickyBar.innerHTML;
      var pricingInView = false;
      var activeIdx = 0;
      var lastRendered = defaultHTML;
      var ratios = tiers.map(function () { return 0; });

      function makeStickyContent(tier) {
        var cta = tier.querySelector('.cta');
        if (!cta) return defaultHTML;
        var clone = cta.cloneNode(true);
        // Adapt for sticky-bar slot: shrink to btn-sm, promote ghost → primary so
        // every tier reads as the dominant action regardless of source styling.
        clone.classList.remove('cta', 'btn-ghost');
        if (!clone.classList.contains('btn-primary')) clone.classList.add('btn-primary');
        clone.classList.add('btn-sm');
        return clone.outerHTML;
      }

      function render() {
        var nextHTML = (pricingInView && tiers[activeIdx])
          ? makeStickyContent(tiers[activeIdx])
          : defaultHTML;
        if (nextHTML !== lastRendered) {
          stickyBar.innerHTML = nextHTML;
          lastRendered = nextHTML;
        }
      }

      // Is the pricing section in view at all?
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { pricingInView = e.isIntersecting; });
        render();
      }, { threshold: 0.15 }).observe(priceGrid);

      // Which tier is most visible inside the horizontal carousel?
      var tierObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var idx = tiers.indexOf(e.target);
          if (idx !== -1) ratios[idx] = e.intersectionRatio;
        });
        var maxRatio = 0, maxIdx = activeIdx;
        for (var i = 0; i < ratios.length; i++) {
          if (ratios[i] > maxRatio) { maxRatio = ratios[i]; maxIdx = i; }
        }
        if (maxRatio > 0.4 && maxIdx !== activeIdx) {
          activeIdx = maxIdx;
          render();
        }
      }, { root: priceGrid, threshold: [0, 0.25, 0.5, 0.75, 1] });
      tiers.forEach(function (t) { tierObserver.observe(t); });
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
